import { render, staticRenderFns } from "./WaitBusinessReturnMoney.vue?vue&type=template&id=2ca20969&scoped=true&"
import script from "./WaitBusinessReturnMoney.vue?vue&type=script&lang=js&"
export * from "./WaitBusinessReturnMoney.vue?vue&type=script&lang=js&"
import style0 from "./WaitBusinessReturnMoney.vue?vue&type=style&index=0&id=2ca20969&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca20969",
  null
  
)

export default component.exports